export const getAuth = () => {
  return {
      method: 'GET',
      headers: {
        "Access-Control-Allow-Origin" : "*",
        "content-type": "text/json",
        "Access-Control-Expose-Headers": "Content-Length, X-JSON, Content-Type",
        "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers":"*",
        "Access-Control-Allow-Credentials": "true"
      }
  };
}


// WEBPACK FOOTER //
// ./src/Components/config/Paths.js